import {
  UPDATE_TABLE,
  RESIZE_TABLE,
  COLAPSE_DASH,
  GET_COLLECTION_TABLE,
  CLOSE_TAB,
  SET_ACTIVE_TAB,
  REPLACE_TAB,
  ADD_SELECT_ITEMS,
  SET_CURRENT_TABLE_STATE,
  SET_CURRENT_TABLE_SORT,
  RESET_TABLE_AND_TABS,
  SET_CURRENT_TABLE_CELL,
  SET_CUSTOM_PROPERTIES,
  EDIT_CUSTOM_PROPERTIES,
  DELETE_CUSTOM_PROPERTIES,
  SET_TABS_TABLE_STATE,
  LOAD_CUSTOM_PROPERTIES,
} from "../constans";

import {
  getSchedule,
  tableSelect,
  resizeViewer,
  getCollectionTable,
  createCustomParameter,
  editCustomParameter,
  deleteCustomParameter,
  getCustomParameters,
  setCustomParameterValues,
  setCustomParameterValuesOfSelection,
} from "../../utils/builder/IScheduleLogic";

import { logError } from "../../utils/builder/IAmecLog";
import { addTranslationsToState } from "./translations";

export const updateTable = (properties, groups) => async (dispatch) => {
  try {
    const res = await getSchedule(properties, groups);
    const customParameters = await getCustomParameters();

    dispatch({
      type: LOAD_CUSTOM_PROPERTIES,
      payload: customParameters
    });

    dispatch({
      type: UPDATE_TABLE,
      payload: { ...res, properties, groups }
    });
    
  } catch (err) {
    logError("FrontEnd.src.store.actions.table.updateTable", err.toString());
  }
};

export const loadCustomProperties = () => async (dispatch) => {
  try {
    const res = await getCustomParameters();

    dispatch({
      type: LOAD_CUSTOM_PROPERTIES,
      payload: res
    });
  }
  catch (err) {
    logError("FrontEnd.src.store.actions.table.loadCustomProperties", err.toString());
  }
}

export const ElementsAction = (elements, modelId = null) => async (dispatch) => {
  try {
    await tableSelect(elements, modelId);
  } catch (err) {
    logError("FrontEnd.src.store.actions.table.ElementsAction", err.toString());
  }
};

export const resizeTable = () => {
  const width = document.getElementById("sidebar").offsetWidth;

  resizeViewer();

  return {
    type: RESIZE_TABLE,
    payload: width,
  };
};

export const colaplseDashboard = (element) => async (dispatch) => {
  await dispatch({
    type: COLAPSE_DASH,
    payload: element,
  });

  resizeViewer();
};

export const getTableCollection = (res) => async (dispatch) => {
  try {
    if (!res.collection) {
      throw new Error('Collection is required');
    }
    
    const tableCollection = await getCollectionTable(res.collection);
    
    if (!tableCollection) {
      throw new Error('Failed to get collection table data');
    }
    
    dispatch(addTranslationsToState(tableCollection.translations))

    await dispatch({
      type: GET_COLLECTION_TABLE,
      payload: { tableCollection, collection: res.collection, folder: res.folder },
    });
  } catch (error) {
    logError("FrontEnd.src.store.actions.table.getTableCollection", error.toString());
    throw error; // Re-throw to allow caller to handle
  }
};

export const closeTab = (tab) => {

  return {
    type: CLOSE_TAB,
    payload: tab,
  };
};

export const setTabActive = (tab) => {

  return {
    type: SET_ACTIVE_TAB,
    payload: tab,
  };
};

export const replaceTab = (res) => {

  return {
    type: REPLACE_TAB,
    payload: res,
  };
};

export const addSelectItems = (res) => ({
  type: ADD_SELECT_ITEMS,
  payload: res,
});


export const setCurrentTableStateAC = (currentTableState) => ({
  type: SET_CURRENT_TABLE_STATE,
  payload: currentTableState,
});

export const setTabsTableStateAC = (currentTableState) => ({
  type: SET_TABS_TABLE_STATE,
  payload: currentTableState,
});

export const setCurrentTableCellAC = (columnId, lineElements, newValue) => async (dispatch) => {
  try {
    const isExternal = typeof window !== 'undefined' && window.__IS_EXTERNAL_TABLE_WINDOW__;
    if (!isExternal) {
      await setCustomParameterValues(columnId, lineElements, newValue);
    }
    dispatch({
      type: SET_CURRENT_TABLE_CELL,
      payload: { columnId, lineElements, newValue },
    });
  } catch (err) {
    dispatch({
      type: SET_CURRENT_TABLE_CELL,
      payload: { columnId, lineElements, newValue },
    });
    logError("FrontEnd.src.store.actions.table.setCurrentTableCellAC", err.toString());
  }
};

export const setCurrentTableFromModelCellAC = (columnId, newValue) => async (dispatch) => {
  try {
    const isExternal = typeof window !== 'undefined' && window.__IS_EXTERNAL_TABLE_WINDOW__;
    if (!isExternal) {
      await setCustomParameterValuesOfSelection(columnId, newValue);
    }
  } catch (err) {
    logError("FrontEnd.src.store.actions.table.setCurrentTableCellAC", err.toString());
  }
};

export const setTableSortingAC = (columnName, sortObj = null) => {
  return {
    type: SET_CURRENT_TABLE_SORT,
    payload: {
      columnName,
      sortObj
    },
  };
}

export const resetTableAndTabsAC = () => {
  return {
    type: RESET_TABLE_AND_TABS,
  };
}

export const setCustomColumn = (name, type, values) => async (dispatch) => {
  try {
    await createCustomParameter(name, type, values)

    const res = await getCustomParameters();

    dispatch({
      type: SET_CUSTOM_PROPERTIES,
      payload: res
    });

  } catch (err) {
    logError("FrontEnd.src.store.actions.table.setCustomColumn", err.toString());
  }
};

export const editCustomColumn = (oldName, newName, prevType, selectedType, values) => async (dispatch) => {
  try {
    await editCustomParameter(oldName, newName, prevType, selectedType, values)

    const res = await getCustomParameters();
    const payload = {
      res: res,
      oldName: oldName,
      name: newName,
      selectedType: selectedType,
    };

    dispatch({
      type: EDIT_CUSTOM_PROPERTIES,
      payload: payload
    });

  } catch (err) {
    logError("FrontEnd.src.store.actions.table.editCustomColumn", err.toString());
  }
};

export const deleteCustomColumn = (name) => async (dispatch) => {
  try {
    await deleteCustomParameter(name)

    const res = await getCustomParameters();
    const payload = { res: res, name: name };

    dispatch({
      type: DELETE_CUSTOM_PROPERTIES,
      payload: payload
    });

  } catch (err) {
    logError("FrontEnd.src.store.actions.table.deleteCustomColumn", err.toString());
  }
};
